import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { ContentAlign, Size } from "../../enums";
import { Asset, Button, RichText } from "../../models";
import { MediaContentType, View } from "./enums";
import { MediaBlock } from "./components/media-block/MediaBlock";
import { ContentBlock } from "./components/content-block/ContentBlock";

type Props = {
  title: RichText;
  text: RichText;
  image?: Asset;
  imageSide: ContentAlign;
  contentAlignment: ContentAlign;
  button?: Button[];
  mediaContentType?: MediaContentType;
  view?: View;
  mobileGapSize?: Size;
  isColorBackground?: boolean;
  isReverseOrder?: boolean;
};

export const SideImage: FC<Props> = ({
  title,
  text,
  image,
  imageSide,
  contentAlignment,
  button,
  mediaContentType,
  view,
  mobileGapSize,
  isColorBackground,
  isReverseOrder,
}) => (
  <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
    <div
      className={classNames(
        "mt-20 flex justify-center px-5",
        "lg:mt-25 lg:px-16",
        "xl:mt-40 xl:px-24",
        { "bg-dark py-20": isColorBackground },
        { "lg:py-25": isColorBackground && view !== View.CONTAINER },
        { "xl:py-30": isColorBackground && view !== View.CONTAINER },
        { "lg:bg-transparent": isColorBackground && view === View.CONTAINER },
      )}
    >
      <div
        className={classNames(
          "flex items-center",
          "lg:w-full lg:flex-row lg:gap-15",
          "xl:max-w-container",
          mobileGapSize === "l" ? "gap-15" : "gap-5",
          { "flex-col-reverse": isReverseOrder },
          { "flex-col": !isReverseOrder },
          { "lg:bg-dark": isColorBackground && view === View.CONTAINER },
          {
            "lg:rounded-lg lg:px-10 lg:py-25":
              isColorBackground && view === View.CONTAINER,
          },
          {
            "lg:px-20 lg:py-30": isColorBackground && view === View.CONTAINER,
          },
        )}
      >
        <MediaBlock {...{ image, imageSide, mediaContentType }} />
        <ContentBlock
          {...{
            title,
            text,
            imageSide,
            contentAlignment,
            button,
            mobileGapSize,
            isReverseOrder,
          }}
        />
      </div>
    </div>
  </Fade>
);
